import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

/**
 * Shows a value (or custom children, e.g. a link) with a copy-to-clipboard
 * button. Renders the plain content when there is nothing to copy.
 */
const CopyText = ({ value, children, ...textProps }) => {
  if (value === null || value === undefined || value === "") {
    return children ?? value ?? null;
  }

  return (
    <Text
      copyable={{ text: String(value), tooltips: ["Copy", "Copied"] }}
      {...textProps}
    >
      {children ?? value}
    </Text>
  );
};

export default CopyText;
